<template>
  <el-card
    class="background"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="deposit-audit">
      <SiruiSearch
        ref="searchRef"
        :query="queryData"
        :columns="topColumns"
        :isQueryPanel="true"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="searchTrigger"
        @changeMethod="changeMethod"
      ></SiruiSearch>
      <div class="result-table">
        <sirui-table
          ref="siruiTable"
          :buttonList="menuButtonList"
          @chooseClick="chooseClick"
          :loading="loading"
          @handleSelectionChange="handleSelectionChange"
          @handleSizeChange="() => getDetailtMgtList()"
          @handleCurrentChange="() => getDetailtMgtList()"
          :data="tableData"
          :paging="true"
          :setting="false"
          :customVisible="false"
          :columns="tableColumns"
          :spanMethod="mergeRowMethod"
          :cellClick="cellClick"
          :cellStyle="cellStyle"
          :footerMethod="footerTotalCols ? footerMethodTotal : null"
          :showFooter="true"
        >
          <vxe-table-column type="checkbox" width="50"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in tableColumns"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template slot-scope="scope">
              <span v-if="item.field == 'contractType'">
                {{ getColumnName('contractType', scope.row[item.field]) }}</span
              >
              <span v-else-if="item.field == 'leaseDuration'">
                {{ getLeaseDuration(scope.row) }}</span
              >
              <span v-else-if="item.field == 'contractStatus'">
                {{ getColumnName('contractStatus', scope.row[item.field]) }}</span
              >
              <span v-else>{{ scope.row[item.field] }}</span>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
    </div>
  </el-card>
</template>

<script>
  import DEPOSITAPI from '@/api/reportManagement';
  import { payableSearchColumns, payableTableColumns } from './columns';
  import ReportMixin from '@/pages/reportManagement/mixins/reportMixin';
  import moment from 'moment';
  export default {
    name: 'DepositOverview',
    mixins: [ReportMixin],
    data() {
      return {
        loading: false,
        tableColumns: [],
        menuButtonList: [], // 表格功能按钮
        value: null,
        treeData: [],
        tableData: [],
        copyTableData: [],
        dateKey: Date.now(),
        queryData: {
          contractCompanyNo: null,
          contractDepartmentNo: null,
          receivableAccountPeriod: null,
          customerName: null,
          projectName: null,
          contractNo: null,
        },
        footerTotalCols: {
          amount: [
            'beginPeriodNotReceived',
            'currentReceivables',
            'totalReceivables',
            'currentReceived',
            'totalReceived',
            'finalNotReceived',
          ],
          quantity: [],
        },
      };
    },
    computed: {
      topColumns() {
        return payableSearchColumns(this);
      },
    },
    created() {},
    mounted() {
      // this.queryData.contractCompanyNo = this.userInfo.companyCode;
      // this.department(this.userInfo.companyCode);
      // this.queryData.contractDepartmentNo = this.userInfo.departmentCode;
      // this.queryData.receivableAccountPeriod = moment(new Date()).format('yyyy-MM');
      this.$refs.siruiTable.setPageSize(10);
      // this.getDetailtMgtList();
      this.getButtonList();
      this.getCompanyList();
    },
    methods: {
      // 表格合并行
      mergeRowMethod({ rowIndex, columnIndex }) {
        switch (
          columnIndex // 将列索引作为判断值
        ) {
          case 0:
            return this.mergeCol('contractNo', rowIndex, this.tableData);
          case 1:
            return this.mergeCol('contractNo', rowIndex, this.tableData);
          case 2:
            return this.mergeCol('contractNo', rowIndex, this.tableData);
          case 3:
            return this.mergeCol('projectName', rowIndex, this.tableData);
          // case 4:
          //   return this.mergeCol('spaceAssetName', rowIndex, this.tableData);
        }
      },
      footerMethodTotal({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            for (let key in this.footerTotalCols) {
              if (this.footerTotalCols[key].includes(column.property)) {
                let total = this.$utils.calSum(data, column.property);
                let point = this.$globalVar.aPoint;
                if (key == 'quantity') {
                  point = this.$globalVar.qPoint;
                }
                total = this.$utils.commafy(this.$utils.toNumber(total).toFixed(point), point);
                return total;
              }
            }
          }),
        ];
      },
      // 获取列表
      async getDetailtMgtList() {
        let params = { ...this.queryData };
        //暂时转换
        params.pageNum = this.$refs.siruiTable.page.pageNum;
        params.pageSize = this.$refs.siruiTable.page.pageSize;
        params = this.filterEmpty(params);
        this.loading = true;
        const { data } = await this.$axios.post(DEPOSITAPI.ACCOUNTS_PAYABLE_LIST, params);
        if (data && data.data && data.code == 0) {
          console.log('depositRes', data);
          this.tableData = data.data.records || [];
          this.copyTableData = JSON.parse(JSON.stringify(data.data.records));
          let list = this.tableStructure(data.data.records);
          this.tableData = list;

          this.$refs.siruiTable.setPageTotal(data.data.total);
          this.$refs.siruiTable.setPageSize(data.data.size);
        } else {
          this.$message.error(data.msg);
        }
        // //清空选择fixme
        this.selectedItems = [];
        this.loading = false;
      },
      handleSure() {
        console.log(1111, '000');
        this.$router.go(0);
        this.resetBtnClick();
      },
      async resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.selectedItems = [];
        // this.queryData.contractCompanyNo = this.userInfo.companyCode;
        this.queryData.contractCompanyName = null;

        // await this.department(this.userInfo.companyCode);
        // this.queryData.contractDepartmentNo = this.userInfo.departmentCode;
        this.queryData.receivableAccountPeriod = moment(new Date()).format('yyyy-MM');
        this.dateKey = Date.now();
        this.getDetailtMgtList();
      },
      handleSelectionChange(row) {
        this.selectedItems = row;
      },
      // 搜索
      searchTrigger() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getDetailtMgtList();
      },

      // 表格上面的按钮
      async chooseClick(type) {
        let empty = !this.selectedItems || !this.selectedItems.length;
        if (empty && type != 'export') {
          this.$message.error('请选择数据！');
          return;
        }
        switch (type) {
          case 'export':
            this.handleExport(this.selectedItems);
            break;
          default:
            break;
        }
      },
      async handleExport(items) {
        console.log('export', items, this.queryData);
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        let params = { ...this.queryData, pageNum, pageSize };
        const ids = [];
        if (items.length) {
          if (params.contractNo) {
            delete params.contractNo;
          }
          if (params.customerName) {
            delete params.customerName;
          }
          items.forEach((item) => {
            ids.push(item.contractNo);
          });
          params.contractNoList = ids;
        }
        let api = DEPOSITAPI.ACCOUNTS_PAYABLE_EXPORT;
        this.$axios.post(api, params).then((res) => {
          console.log(res, 'export res');
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //获取当前列数据
      getColumnInfo() {
        this.getColumnList(payableTableColumns()).then(() => {
          this.tableColumns = payableTableColumns();
        });
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          console.log('menuButtons', this.menuButtonList);
          this.getColumnInfo();
        });
      },
      cellStyle({ column }) {
        if (column.property == 'contractNo') {
          return {
            color: '#009fcc',
          };
        }
      },
      cellClick(val) {
        if (val.column?.property == 'contractNo') {
          this.handleContractDetail(val.row);
        }
      },
      handleContractDetail(row) {
        console.log(row, '数据');
        let suffix = '';
        let name = '';
        let query = { contractCode: row.contractNo, origin: 'detail', pageMode: 1 };
        if (row.isCs == 'C') {
          suffix = 'customerContractDetail';
          name = '客方合同详情';
        } else {
          suffix = 'supplierContractDetail';
          name = '供方合同详情';
        }

        let path = {
          path: '/intermodality/' + suffix,
          name: suffix,
          meta: {
            keepAlive: true,
            title: name,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
